import { useDispatch, useSelector } from "react-redux";
import { GameShopSlider } from "../components/gameShop/gameShopSlider/GameShopSlider";
import { openShopWinnersPopup } from "../redux/actions";
import { ShopWinnersPopup } from "../components/popups/ShopWinnersPopup";
import { WinnersSlider } from "../components/sliders/winnersSlider/WinnersSlider";
import style from './shop.module.scss';

export const Shop = () => {
  const dispatch = useDispatch();
  const winners = useSelector(state => state.game.gameShop.winners)
  const showWinners = useSelector(state => state.game.gameShop.settings?.showWinners)
  const lang = useSelector(state => state.app.currentLang);

  return (
    <>
      <GameShopSlider />
      {
        winners.length >= 3 && <div className={"shop " + style['shop__block']}>
          <div className={style['shop__panel']}>
            <div className={style['shop__panel_center']}>
              <div className={style['shop__title']}>
                {lang.shop.title}
              </div>
              <div className={style['shop__subtitle']}>
                {lang.games4}
              </div>
            </div>
            <div className={style['shop__panel_right']}>
              {showWinners &&
                <div className='game__panel_button' onClick={() => dispatch(openShopWinnersPopup())}>
                  <div className='game__icon2'></div>
                </div>
              }
            </div>
          </div>
          {
            winners.length >= 3 && <WinnersSlider className='shop' winners={winners} showWinners={showWinners} getWinnersPopup={openShopWinnersPopup} />
          }
          <ShopWinnersPopup />
        </div>
      }
    </>
  )

}